export const DENTAL = {
  nickname: 'PRODUCTS.DENTAL.nickname',
  icon:'dental'
};
